/**
 * @generated by @interxfi/j5-codegen (Plugin: I18nPlugin) - do not edit */

import i18n, { type TFunction } from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';
import enCommonNs from '../translations/en/common.json';
import enEntityNs from '../translations/en/entity.json';
import enExcDtcDtccaV1Ns from '../translations/en/exc-dtc-dtcca-v1.json';
import enExcDtcFilesV1Ns from '../translations/en/exc-dtc-files-v1.json';
import enExcDtccUtcV1Ns from '../translations/en/exc-dtcc-utc-v1.json';
import enExcFixV1Ns from '../translations/en/exc-fix-v1.json';
import enExcIceCorpactionsV1Ns from '../translations/en/exc-ice-corpactions-v1.json';
import enExcIceGsmV1Ns from '../translations/en/exc-ice-gsm-v1.json';
import enExcIceJobV1Ns from '../translations/en/exc-ice-job-v1.json';
import enExcIncreaseV1Ns from '../translations/en/exc-increase-v1.json';
import enExcJaneStreetV1Ns from '../translations/en/exc-jane-street-v1.json';
import enExcJpmamV1Ns from '../translations/en/exc-jpmam-v1.json';
import enExcMarketdataV1Ns from '../translations/en/exc-marketdata-v1.json';
import enExcPlaidV1Ns from '../translations/en/exc-plaid-v1.json';
import enExcQuotemediaV1Ns from '../translations/en/exc-quotemedia-v1.json';
import enExcRouteV1Ns from '../translations/en/exc-route-v1.json';
import enExfOfacEmulatorV1Ns from '../translations/en/exf-ofac-emulator-v1.json';
import enIsoV1Ns from '../translations/en/iso-v1.json';
import enIxcAssetsClearingV1Ns from '../translations/en/ixc-assets-clearing-v1.json';
import enIxcAssetsV1Ns from '../translations/en/ixc-assets-v1.json';
import enIxcBillingV1Ns from '../translations/en/ixc-billing-v1.json';
import enIxcCasesV1Ns from '../translations/en/ixc-cases-v1.json';
import enIxcClearingV1Ns from '../translations/en/ixc-clearing-v1.json';
import enIxcCorpactionsCaadminV1Ns from '../translations/en/ixc-corpactions-caadmin-v1.json';
import enIxcCorpactionsCadataV1Ns from '../translations/en/ixc-corpactions-cadata-v1.json';
import enIxcCorpactionsV1Ns from '../translations/en/ixc-corpactions-v1.json';
import enIxcCostbasisV1Ns from '../translations/en/ixc-costbasis-v1.json';
import enIxcDtccCnsV1Ns from '../translations/en/ixc-dtcc-cns-v1.json';
import enIxcDtccDrecoV1Ns from '../translations/en/ixc-dtcc-dreco-v1.json';
import enIxcDtccDtcV1Ns from '../translations/en/ixc-dtcc-dtc-v1.json';
import enIxcFeesV1Ns from '../translations/en/ixc-fees-v1.json';
import enIxcFundingV1Ns from '../translations/en/ixc-funding-v1.json';
import enIxcGenerateV1Ns from '../translations/en/ixc-generate-v1.json';
import enIxcInventoryV1Ns from '../translations/en/ixc-inventory-v1.json';
import enIxcMfrecoV1Ns from '../translations/en/ixc-mfreco-v1.json';
import enIxcMutualfundsV1Ns from '../translations/en/ixc-mutualfunds-v1.json';
import enIxcOrdersV1Ns from '../translations/en/ixc-orders-v1.json';
import enIxcPaymentsV1Ns from '../translations/en/ixc-payments-v1.json';
import enIxcPortfolioV1Ns from '../translations/en/ixc-portfolio-v1.json';
import enIxcProspectusV1Ns from '../translations/en/ixc-prospectus-v1.json';
import enIxcProxyvoteV1Ns from '../translations/en/ixc-proxyvote-v1.json';
import enIxcQuoteV1Ns from '../translations/en/ixc-quote-v1.json';
import enIxcRaglV1Ns from '../translations/en/ixc-ragl-v1.json';
import enIxcRegistrationV1Ns from '../translations/en/ixc-registration-v1.json';
import enIxcSweepsClearingV1Ns from '../translations/en/ixc-sweeps-clearing-v1.json';
import enIxcSweepsV1Ns from '../translations/en/ixc-sweeps-v1.json';
import enIxcTradeV1Ns from '../translations/en/ixc-trade-v1.json';
import enIxcTradereportingV1Ns from '../translations/en/ixc-tradereporting-v1.json';
import enIxcTrfV1Ns from '../translations/en/ixc-trf-v1.json';
import enIxfAccountingV1Ns from '../translations/en/ixf-accounting-v1.json';
import enIxfDocumentsV1Ns from '../translations/en/ixf-documents-v1.json';
import enIxfHoursV1Ns from '../translations/en/ixf-hours-v1.json';
import enIxfReportsV1Ns from '../translations/en/ixf-reports-v1.json';
import enIxfWatchlistV1Ns from '../translations/en/ixf-watchlist-v1.json';
import enIxmAgentauthV1Ns from '../translations/en/ixm-agentauth-v1.json';
import enIxmAuthV1Ns from '../translations/en/ixm-auth-v1.json';
import enIxmEmailV1Ns from '../translations/en/ixm-email-v1.json';
import enIxmEventsV1Ns from '../translations/en/ixm-events-v1.json';
import enIxmMcpV1Ns from '../translations/en/ixm-mcp-v1.json';
import enIxmTriggerV1Ns from '../translations/en/ixm-trigger-v1.json';
import enIxmUserauthV1Ns from '../translations/en/ixm-userauth-v1.json';
import enIxtBuildsV1Ns from '../translations/en/ixt-builds-v1.json';
import enIxtE2eV1Ns from '../translations/en/ixt-e2e-v1.json';
import enJ5AuthV1Ns from '../translations/en/j5-auth-v1.json';
import enJ5ClientV1Ns from '../translations/en/j5-client-v1.json';
import enJ5DrssV1Ns from '../translations/en/j5-drss-v1.json';
import enJ5ListV1Ns from '../translations/en/j5-list-v1.json';
import enJ5RegistryV1Ns from '../translations/en/j5-registry-v1.json';
import enJ5SchemaV1Ns from '../translations/en/j5-schema-v1.json';
import enJ5StateV1Ns from '../translations/en/j5-state-v1.json';
import enO5ApplicationV1Ns from '../translations/en/o5-application-v1.json';
import enO5AwsDeployerV1Ns from '../translations/en/o5-aws-deployer-v1.json';
import enO5DanteV1Ns from '../translations/en/o5-dante-v1.json';
import enO5EnvironmentV1Ns from '../translations/en/o5-environment-v1.json';
import enO5MessagingV1Ns from '../translations/en/o5-messaging-v1.json';

export const i18nOpts = {
  defaultNS: 'common',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  lng: 'en',
  resources: {
    en: {
      common: enCommonNs,
      entity: enEntityNs,
      excDtcDtccaV1: enExcDtcDtccaV1Ns,
      excDtcFilesV1: enExcDtcFilesV1Ns,
      excDtccUtcV1: enExcDtccUtcV1Ns,
      excFixV1: enExcFixV1Ns,
      excIceCorpactionsV1: enExcIceCorpactionsV1Ns,
      excIceGsmV1: enExcIceGsmV1Ns,
      excIceJobV1: enExcIceJobV1Ns,
      excIncreaseV1: enExcIncreaseV1Ns,
      excJaneStreetV1: enExcJaneStreetV1Ns,
      excJpmamV1: enExcJpmamV1Ns,
      excMarketdataV1: enExcMarketdataV1Ns,
      excPlaidV1: enExcPlaidV1Ns,
      excQuotemediaV1: enExcQuotemediaV1Ns,
      excRouteV1: enExcRouteV1Ns,
      exfOfacEmulatorV1: enExfOfacEmulatorV1Ns,
      isoV1: enIsoV1Ns,
      ixcAssetsClearingV1: enIxcAssetsClearingV1Ns,
      ixcAssetsV1: enIxcAssetsV1Ns,
      ixcBillingV1: enIxcBillingV1Ns,
      ixcCasesV1: enIxcCasesV1Ns,
      ixcClearingV1: enIxcClearingV1Ns,
      ixcCorpactionsCaadminV1: enIxcCorpactionsCaadminV1Ns,
      ixcCorpactionsCadataV1: enIxcCorpactionsCadataV1Ns,
      ixcCorpactionsV1: enIxcCorpactionsV1Ns,
      ixcCostbasisV1: enIxcCostbasisV1Ns,
      ixcDtccCnsV1: enIxcDtccCnsV1Ns,
      ixcDtccDrecoV1: enIxcDtccDrecoV1Ns,
      ixcDtccDtcV1: enIxcDtccDtcV1Ns,
      ixcFeesV1: enIxcFeesV1Ns,
      ixcFundingV1: enIxcFundingV1Ns,
      ixcGenerateV1: enIxcGenerateV1Ns,
      ixcInventoryV1: enIxcInventoryV1Ns,
      ixcMfrecoV1: enIxcMfrecoV1Ns,
      ixcMutualfundsV1: enIxcMutualfundsV1Ns,
      ixcOrdersV1: enIxcOrdersV1Ns,
      ixcPaymentsV1: enIxcPaymentsV1Ns,
      ixcPortfolioV1: enIxcPortfolioV1Ns,
      ixcProspectusV1: enIxcProspectusV1Ns,
      ixcProxyvoteV1: enIxcProxyvoteV1Ns,
      ixcQuoteV1: enIxcQuoteV1Ns,
      ixcRaglV1: enIxcRaglV1Ns,
      ixcRegistrationV1: enIxcRegistrationV1Ns,
      ixcSweepsClearingV1: enIxcSweepsClearingV1Ns,
      ixcSweepsV1: enIxcSweepsV1Ns,
      ixcTradeV1: enIxcTradeV1Ns,
      ixcTradereportingV1: enIxcTradereportingV1Ns,
      ixcTrfV1: enIxcTrfV1Ns,
      ixfAccountingV1: enIxfAccountingV1Ns,
      ixfDocumentsV1: enIxfDocumentsV1Ns,
      ixfHoursV1: enIxfHoursV1Ns,
      ixfReportsV1: enIxfReportsV1Ns,
      ixfWatchlistV1: enIxfWatchlistV1Ns,
      ixmAgentauthV1: enIxmAgentauthV1Ns,
      ixmAuthV1: enIxmAuthV1Ns,
      ixmEmailV1: enIxmEmailV1Ns,
      ixmEventsV1: enIxmEventsV1Ns,
      ixmMcpV1: enIxmMcpV1Ns,
      ixmTriggerV1: enIxmTriggerV1Ns,
      ixmUserauthV1: enIxmUserauthV1Ns,
      ixtBuildsV1: enIxtBuildsV1Ns,
      ixtE2eV1: enIxtE2eV1Ns,
      j5AuthV1: enJ5AuthV1Ns,
      j5ClientV1: enJ5ClientV1Ns,
      j5DrssV1: enJ5DrssV1Ns,
      j5ListV1: enJ5ListV1Ns,
      j5RegistryV1: enJ5RegistryV1Ns,
      j5SchemaV1: enJ5SchemaV1Ns,
      j5StateV1: enJ5StateV1Ns,
      o5ApplicationV1: enO5ApplicationV1Ns,
      o5AwsDeployerV1: enO5AwsDeployerV1Ns,
      o5DanteV1: enO5DanteV1Ns,
      o5EnvironmentV1: enO5EnvironmentV1Ns,
      o5MessagingV1: enO5MessagingV1Ns,
    },
  },
  showSupportNotice: false,
} as const;

export type I18nResources = (typeof i18nOpts)['resources']['en'];

export type I18nNamespaces = keyof I18nResources;

export type I18nNamespaceEnum<T extends I18nNamespaces> = I18nResources[T] extends {
  enum: infer V;
}
  ? keyof V
  : never;

export type I18nNamespaceOneOf<T extends I18nNamespaces> = I18nResources[T] extends {
  oneOf: infer V;
}
  ? keyof V
  : never;

export type I18nNamespacePolymorph<T extends I18nNamespaces> = I18nResources[T] extends {
  polymorph: infer V;
}
  ? keyof V
  : never;

export type I18nNamespaceFilterEnum<T extends I18nNamespaces> = I18nResources[T] extends {
  filterEnum: infer V;
}
  ? keyof V
  : never;

export type I18nNamespaceSearchEnum<T extends I18nNamespaces> = I18nResources[T] extends {
  searchEnum: infer V;
}
  ? keyof V
  : never;

export type I18nNamespaceSortEnum<T extends I18nNamespaces> = I18nResources[T] extends {
  sortEnum: infer V;
}
  ? keyof V
  : never;

type StripPluralSuffix<T> = T extends `${infer Base}_one` ? Base : T extends `${infer Base}_other` ? Base : T;

export type I18nNamespaceEntity = StripPluralSuffix<keyof I18nResources['entity']>;

i18n.use(initReactI18next).init(i18nOpts);

export * from '../components';
export { type TFunction, i18n, useTranslation };
